import { createAction } from '@reduxjs/toolkit';
export var setGenericError = createAction('setGenericError');
export var setMfa = createAction('setMfa');
export var setLoading = createAction('setLoading');
export var emailBlur = createAction('emailBlur');
export var setPxCaptchaType = createAction('setPxCaptchaType');